
import {get_token, get_user_details} from "@/router";
import { client_domain } from "@/main.js";
import { get_active_organization_id, is_organization_admin_role } from "@/utils/organization_profile";
import { view_profile as view_profile_helper } from "@/views/Feed/feed_helper.js";

export default {
  inject: ['client_features'],
  computed: {

    filtered_business() {
        return this.showAll ? this.business_profiles : this.business_profiles.slice(0, this.visibleCount);
      },
    can_create_business_profile() {
      return this.is_enabled_feature(this.client_features?.show_business_profile)
        && !is_organization_admin_role(this.user_details);
      }
  },

  mounted() {

    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.fetchCompanyProfile()
    if(client_domain.includes('tdm') || client_domain.includes('chamber')|| client_domain.includes('cbo') || client_domain.includes('engagenet')){
      this.visible_domain = true;

    }
  },
  data() {
    return ({
    business_profiles:[],
    token_exists: false,
    user_details: {},
    visibleCount: 4,
    visible_domain:false,
    showAll: false, 
    following_profile_ids: {},


    });
  },
  methods: {
    is_enabled_feature(value) {
        return value === true || value === 'true' || value === 1 || value === '1';
    },
    getToken() {
        return get_token();
    },
    shuffle_list(items) {
      return [...items].sort(() => Math.random() - 0.5);
    },
    get_profile_logo(profile) {
      return profile?.base_profile?.profile_files?.[0]?.file?.file_url
        || profile?.profile_files?.[0]?.file?.file_url
        || '';
    },
    get_profile_name(profile) {
      return profile?.company_name || profile?.base_profile?.profile_name || 'Business Profile';
    },
    get_profile_initials(profile) {
      return this.get_profile_name(profile)
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(word => word[0].toUpperCase())
        .join('');
    },
    get_profile_meta(profile) {
      return profile?.followed_by
        ? `Followed by ${profile.followed_by}`
        : profile?.is_following
          ? 'Followed by you'
          : 'Suggested for you';
    },
    is_followed_profile(profile) {
      return Boolean(profile?.is_following || profile?.is_followed || profile?.followed);
    },
    get_follow_label(profile) {
      return this.is_followed_profile(profile) ? 'Followed' : 'Follow';
    },
    set_profile_follow_state(profile, profile_data) {
      if (typeof profile_data?.is_following !== 'undefined') {
        profile.is_following = profile_data.is_following;
      }
    },
    get_base_profile_id(profile) {
      return profile?.base_profile?.id || profile?.base_profile_id || profile?.profile?.base_profile?.id;
    },
    is_following_profile(profile) {
      const base_profile_id = this.get_base_profile_id(profile);
      return (
        Boolean(base_profile_id) &&
        Reflect.has(this.following_profile_ids, String(base_profile_id))
      );
    },
    follow_profile(profile) {
      const base_profile_id = this.get_base_profile_id(profile);
      if (!base_profile_id || this.is_following_profile(profile)) return;

      Reflect.set(
        this.following_profile_ids,
        String(base_profile_id),
        true
      );

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/follow_profile/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ target_base_profile_id: base_profile_id }),
        success: (response) => {
          if (response.status === "success") {
            profile.is_following = response.is_following;
          }
        },
        error: (xhr, status, error) => {
          console.error("Error following profile:", error);
        },
        complete: () => {
            Reflect.set(
              this.following_profile_ids,
              String(base_profile_id),
              false
            );
        },
      });
    },
    first_present_value(...values) {
      return values.find((value) => value !== undefined && value !== null && String(value).trim() !== "") || "";
    },
    get_business_profiles_request_params() {
      const organization_id = get_active_organization_id();
      return organization_id ? { organization_id } : {};
    },

    fetchCompanyProfile() {
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_company_profile/`,
            type: "GET",
            headers: {
                Authorization: `Token ${get_token()}`,
                "Content-Type": "application/json",
            },
            data: this.get_business_profiles_request_params(),
            success: (response) => {
                if (response.status === "success") {
                 this.business_profiles=this.shuffle_list(response.data)
                 this.hydrate_visible_business_follow_states();
                }
            },
            error: (xhr, status, error) => {
                console.error("Error fetching company profile:", error);
            }
        });
      },
      hydrate_visible_business_follow_states() {
        this.filtered_business.forEach((profile) => {
          const base_profile_id = this.get_base_profile_id(profile);
          if (!base_profile_id || typeof profile.is_following !== 'undefined') return;

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile/`,
            type: "GET",
            headers: {
              Authorization: `Token ${get_token()}`,
              "Content-Type": "application/json",
            },
            data: { base_profile_id },
            success: (response) => {
              const profile_data = response?.data?.profile_data;
              if (response.status === "success" && profile_data) {
                this.set_profile_follow_state(profile, profile_data);
              }
            },
            error: (xhr, status, error) => {
              console.error("Error loading business follow state:", error);
            },
          });
        });
      },
      view_profile(profile){
        view_profile_helper(this.$router, {
          ...profile,
          company_id: profile?.id,
          id: this.get_base_profile_id(profile),
          profile_type: 'business',
        });
      }
  },
};
